import React from "react";
import PublicNav from "./PublicNav";
import Footer from "./Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-white text-slate-950">
      <PublicNav />
      <main className="pt-16">{children}</main>
      <Footer />
    </div>
  );
}
